<app-dashboard-sidemenu></app-dashboard-sidemenu>


<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">


	<app-dashboard-navbar></app-dashboard-navbar>


	<!-- Breadcrumb Area -->
	<div *ngFor="let Content of breadcrumb;" class="breadcrumb-area">
		<h1>{{Content.title}}</h1>
		<ol class="breadcrumb">
			<li class="item">
				<a routerLink="/">Home</a>
			</li>
			<li class="item">
				<a routerLink="/dashboard">
					{{Content.subTitle}}
				</a>
			</li>
			<li class="item">{{Content.title}}</li>
		</ol>
	</div>
	<!-- End Breadcrumb Area -->
	<div class="text-right add-listings-btn">
		<div class="form-group">
			<button type="submit" class="submit_btn m-0" routerLink="/tool-loan" style="margin-right:5px !important;"
				*ngIf="(role.roleName === 'Admin' || role.checker1 == true)  && !toggleValue">
				Add
			</button>
			<button type="submit" class="submit_btn m-0" (click)="uploadDailog()" style="margin-right:5px !important;"
				*ngIf="toggleValue && role.checker2 == false">
				Upload Invoice
			</button>
			<button type="submit" class="submit_btn m-0" (click)="sendtoolforcheckup()"
				style="margin-right:5px !important;"
				*ngIf="(role.checker1==true ||role.roleName ==='Admin') && toggleValue">
				Send to Supplier For Health Checkup
			</button>
			<button type="submit" class="submit_btn m-0" (click)="generatetoolloan()"
				style="margin-right:5px !important;"
				*ngIf="(role.roleName === 'Supplier' || role.roleName === 'Admin') && !toggleValue">
				Generate Tool Agreement
			</button>
			<button type="submit" class="submit_btn m-0" (click)="onAprrovPress()" style="margin-right:5px !important;"
				*ngIf="(role.roleName === 'Admin' || role.checker1 == true)  && toggleValue">
				Checker 1 Verification
			</button>
			<button type="submit" class="submit_btn m-0" (click)="checker2process()" style="margin-right:5px !important;"
				*ngIf="(role.roleName === 'Admin' || (role.checker2 == true && role.roleName === 'Bussiness head'))  && toggleValue">
				Approval Authority
			</button>
			<button type="submit" class="submit_btn m-0" (click)="checker3process()"
				*ngIf="(role.roleName === 'Admin' || (role.checker2 == true && role.roleName === 'User'))  && toggleValue">
				Checker 3 Verification
			</button>
		</div>
	</div>
	<!-- <div class="text-right add-listings-btn" *ngIf="role.roleName === 'Supplier'">
		<div class="form-group">
			<button type="submit" class="submit_btn m-0" style="margin-right:5px !important;" (click)="downloadFile()">
				Download
			</button>
			<button type="submit" class="submit_btn m-0" (click)="uploadDailog()">
				Upload
			</button>
		</div>
	</div> -->
	<!-- <p-table #dt2 [value]="supplierEnquiryData" dataKey="supplierId" [rows]="10" responsiveLayout="scroll"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]" [paginator]="true"
        currentPageReportTemplate="Showing {first} to
        {last} of {totalRecords} entries" [filterDelay]="0" [globalFilterFields]="['mobileNo', 'enquiryNo' , 'supplierName' ,
        'itemName']">
        <ng-template pTemplate="caption">
            <span class="p-input-icon-left d-flex align-items-center">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value,
                    'contains')" placeholder="Global Search" [(ngModel)]="filterval" />
                <p-button type="button" class="ml-2" (click)="reset(dt2)" icon="bx bx-reset"></p-button>
            </span>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>S.No.</th>
                <th>Action</th>
                <th>Mail Status</th>
                <th>Enquiry No.</th>
                <th>Enquiry Date</th>
                <th>Part Number</th>
                <th>User Name</th>
                <th>Supplier Name</th>
                <th>Mobile No</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-i="rowIndex">
            <tr class="p-selectable-row">
                <td>{{i+1}}</td>
                <td class="d-flex" style="align-items: center;">
                    <button pButton pRipple type="button" (click)="getToolLoan(customer)" pTooltip="Add Documents"
                        icon="bx bx-show" class="p-button-rounded p-button-primary p-button-text"></button>
                    <button pButton pRipple type="button" *ngIf="customer.toolLoanAgreementId == 0"
                        (click)="sendMail(customer)" pTooltip="Send Mail" icon="bx bxs-send"
                        class="p-button-rounded p-button-primary p-button-text"></button>
                </td>
                <td style="padding: 0.1rem 0.4rem!important;">
                    <button pButton pRipple type="button" *ngIf="customer.toolLoanAgreementId > 0"
                        icon="bx bx-check-circle" class="p-button-rounded p-button-success  p-button-text"></button>
                    <button pButton pRipple type="button" *ngIf="customer.toolLoanAgreementId == 0"
                        icon="pi pi-times-circle" class="p-button-rounded p-button-danger p-button-text"></button>
                </td>
                <td>{{customer.enquiryNo}}</td>
                <td>{{customer.enquiryDate | date}}</td>
                <td>{{customer.itemName}}</td>
                <td> <span>{{customer.userName ?? '-'}}</span></td>
                <td> <span>{{customer.supplierName }}</span></td>
                <td>
                    <span class="image-text">{{customer.mobileNo}}</span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No customers found.</td>
            </tr>
        </ng-template>
    </p-table> -->


	<p-table #dt2 [value]="ToolListData" *ngIf="!toggleValue" [rows]="10" responsiveLayout="scroll"
		[showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]" [paginator]="true"
		currentPageReportTemplate="Showing {first} to
    {last} of {totalRecords} entries" [filterDelay]="0" [sortMode]="'single'"
		[globalFilterFields]="['businessUnit', 'supplierName','currencyName','packageNumber','orderNumber','jdecode']">
		<ng-template pTemplate="caption">
			<div class="d-flex align-items-center " style="width: 100%;">

				<span class="p-input-icon-left d-flex align-items-center">
					<i class="pi pi-search"></i>
					<input [(ngModel)]="filterval" (input)="dt2.filterGlobal($event.target.value,
                'contains')" pInputText type="text" placeholder="Global Search">
					<p-button (click)="reset(dt2)" type="button" class="ml-2" icon="bx bx-reset"></p-button>
				</span>
				<div class="ml-3 d-flex align-items-center">
					<span style="font-size: 14px;">Package Wise list</span>
					<div class="ml-5 d-flex align-items-center gap-2 form-check form-switch" style="margin-top: -2px;">

						<input class="form-check-input" type="checkbox" style="cursor: pointer;" role="switch"
							id="flexSwitchCheckDefault" [(ngModel)]="toggleValue" (change)="onToggleChange($event)">
					</div>
					<!-- <p-inputSwitch [(ngModel)]="toggleValue" (onChange)="onToggleChange($event)"></p-inputSwitch> -->
					<span style="font-size: 14px;">Asset Wise list</span>
				</div>

			</div>
		</ng-template>


		<ng-template pTemplate="header">
			<tr>
				<th>S.No.</th>
				<th style="text-align: center;">Action</th>
				<th style="text-align: center;">Tool Signed</th>
				<!-- <th style="text-align: center;">Checker 1</th>
				<th style="text-align: center;">checker 1 Remark</th>
				<th style="text-align: center;">Checker 2</th> -->
				<th pSortableColumn="packageNumber">Package Asset Code
					<p-sortIcon field="packageNumber"></p-sortIcon>
				</th>
				<!-- <th>Tool New Or Shifted</th> -->
				<th>BU</th>
				<th>Business Unit</th>
				<th>PO Type</th>
				<th>PO No.</th>
				<!-- <th>Tool Description</th> -->
				<th>Supplier Name</th>
				<th>Supplier Code</th>
				<th style="text-align: center;">Download Agreement</th>
				<!-- <th>Asset Code</th>
				<th>Remarks</th> -->
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-tool let-i="rowIndex">
			<tr class="p-selectable-row">
				<td>{{i+1}}</td>
				<!-- <td class="d-flex" style="align-items: center;"> -->

				<!-- <button pButton pRipple type="button" 
                     pTooltip="Send Mail" icon="bx bxs-send"
                    class="p-button-rounded p-button-primary p-button-text"></button>  -->
				<!-- </td> -->
				<!-- <td style="padding: 0.1rem 0.4rem!important;">
                <button pButton pRipple type="button" 
                    icon="bx bx-check-circle" class="p-button-rounded p-button-success  p-button-text"></button>
                <button pButton pRipple type="button" 
                    icon="pi pi-times-circle" class="p-button-rounded p-button-danger p-button-text"></button>
            </td> -->
				<!-- <td>{{tool.toolListId}}</td> -->
				<td>

					<div class="delete-checkbox-onerow" style="display: flex; align-items: center;">
						<button pButton pRipple type="button" (click)="openmodal(tool.toolLoanMasterId)"
							icon="bx bx-show" class="p-button-rounded p-button-primary p-button-text"></button>
						<button *ngIf="role.roleName === 'Supplier'&& tool.documentSigned == true" pButton pRipple
							type="button" icon="bx bx-pencil" class="p-button-rounded p-button-primary
							p-button-text" (click)="editmodal(tool.toolLoanMasterId)"></button>
						<ng-container
							*ngIf="role.roleName === 'Admin' || role.roleName === 'Finance' || role.checker1 == true || role.roleName == 'Supplier'">
							<input type="checkbox" [(ngModel)]="tool.selected"
								[disabled]="tool.disabled||tool.documentSigned" (change)="updateCheckboxState()"
								style="cursor: pointer;">
						</ng-container>
						<!-- <button pButton pRipple type="button" (click)="navigateToolForm(tool.toolListId)"
							icon="bx bx-show" class="p-button-rounded p-button-primary
						p-button-text" *ngIf="role.roleName === 'Finance' || role.checker1 == true"></button> -->
						<!-- <ng-container>
							<button pButton pRipple icon="pi pi-external-link"
								class="p-button-rounded p-button-info p-button-text"
								(click)="onAprrovPress(tool.toolLoanMasterId, 'verify')" pTooltip="Actions"
								tooltipPosition="bottom"></button>
						</ng-container> -->
					</div>


				</td>

				<td style="text-align: center;">
					<span>
						<span class="product-badge status-Acknowledged"
							*ngIf="tool.documentSigned == true">Signed</span>
						<span *ngIf="tool.documentSigned == false" class="product-badge status-">Not Signed</span>
					</span>
				</td>
				<!-- <td>
					<button pButton pRipple type="button" *ngIf="tool.checker1Status== 'Approved'" [label]="'Approved'" class="p-button-rounded
						p-button-success status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="tool.checker1Status == 'Pending'" [label]="'Pending'" class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
							<button pButton pRipple type="button" *ngIf="tool.checker1Status == 'Rework'" 
							[label]="'Rework'" class="p-button-rounded
							p-button-info status_button" style="font-size:
							12px; padding:
							0.2rem 1rem;"></button>
	
				</td>
				<td>{{tool.approvedRemark || '-'}}</td>
				<td *ngIf="tool.checker1Status == 'Rework'"  >{{tool.RejectedRemark || '-'}}</td>
				<td>
					<button pButton pRipple type="button" *ngIf="tool.checker2Status== 'Approved'" [label]="'Approved'" class="p-button-rounded
						p-button-success status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="tool.checker2Status == 'Pending'" [label]="'Pending'" class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
						<button pButton pRipple type="button" *ngIf="tool.checker2Status == 'Rework'" 
						[label]="'Rework'" class="p-button-rounded
						p-button-info status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
				</td> -->
				<td>{{tool.packageNumber ||'-'}}</td>
				<!-- <td>{{tool.toolType ||'-'}}</td> -->
				<td>{{tool.bu || '-'}}</td>
				<td>
					{{tool.businessUnit || '-'}}
				</td>
				<td>{{tool.poType || '-'}}</td>
				<td>
					<span>{{tool.orderNumber|| '-'}}</span>
				</td>
				<!-- <td>
					<span>
						{{tool.itemDescription }}
					</span>
				</td> -->
				<td>
					<span>
						{{tool.supplierName || '-' }}
					</span>
				</td>
				<td> <span>{{tool.jdecode || '-' }}</span></td>
				<td style="    text-align: center; "> <button (click)="openmodal2(tool.toolLoanMasterId)" pButton
						pRipple type="button" icon="bx bx-download" class="p-button-rounded p-button-text
			p-button-teaxt"></button>
				</td>
				<!-- <td>
					<span>
						{{tool.assetCode }}
					</span>
				</td> -->

				<!-- <td>
					<span>{{tool.remark}}</span>
				</td> -->



			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="5">No data found.</td>
			</tr>
		</ng-template>
	</p-table>
	<p-table [(selection)]="selectedItems" *ngIf="toggleValue" #dtAssetList [value]="alldata" [selectionMode]="multiple"
		[rows]="10" responsiveLayout="scroll" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]"
		[paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[globalFilterFields]="['assetCode','packageNumber','itemDescription','supplierName','capital','isApproved','orderNumber']"
		[sortMode]="'single'">
		<ng-template pTemplate="caption">
			<div class="d-flex align-items-center">
				<div class="d-flex align-items-center">
					<span class="p-input-icon-left d-flex align-items-center">
						<i class="pi pi-search"></i>
						<input [(ngModel)]="filterval2"
							(input)="dtAssetList.filterGlobal($event.target.value, 'contains')" pInputText type="text"
							placeholder="Global Search" />
						<p-button (click)="reset2(dtAssetList)" type="button" class="ml-2"
							icon="bx bx-reset"></p-button>
					</span>

				</div>

				<div class="ml-3 d-flex align-items-center">
					<span style="font-size: 14px;">Package Wise list</span>
					<div class="ml-5 d-flex align-items-center gap-2 form-check form-switch" style="margin-top: -2px;">
						<input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
							[(ngModel)]="toggleValue" style="cursor: pointer;" />

					</div>
					<span style="font-size: 14px;">Asset Wise list</span>
				</div>
			</div>
		</ng-template>

		<ng-template pTemplate="header">
			<tr>
				<th style="width: 3em">
					<input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)"
						style="cursor: pointer;" />

				</th>
				<th>S.No.</th>
				<th>Package Code</th>
				<th pSortableColumn="assetCode">Asset Code <p-sortIcon field="assetCode"></p-sortIcon></th>
				<th>Item Description</th>
				<th>Item Number</th>
				<th>Supplier Name</th>
				<th style="text-align:center;">Document Preview</th>
				<th style="text-align:center;">Invoice Preview</th>
				<th>Download Agreement</th>
				<th>Tool Shifted Or Not</th>
				<th>Order Number</th>
				<th>Agreement Date</th>
				<th style="text-align:center;">Checker 1</th>
				<th>Checker 1 Remark</th>
				<th style="text-align:center;">Checker 2</th>
				<th>Checker 2 Remark</th>
				<th style="text-align:center;">Checker 3</th>
				<th>Checker 3 Remark</th>
				<th style="text-align:center;">Tool Signed</th>
				<!-- <th style="text-align:center;">Document Uploaded</th> -->
				<th style="text-align:center;">Invoice Uploaded</th>
				<!-- <th style="text-align:center;">Document Preview</th>
				<th style="text-align:center;">Invoice Preview</th>
				<th>Download Agreement</th> -->
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-asset let-i="rowIndex">
			<tr class="p-selectable-row">
				<!-- <td>
		  <p-tableCheckbox [value]="asset"></p-tableCheckbox>
		</td> -->

				<td>
					<input type="checkbox" [checked]="isSelected(asset)" (change)="toggleSelection(asset)"
						style="cursor:pointer" [disabled]="asset.shiftedDone" />
				</td>
				<td>{{ i + 1 }}</td>
				<td>{{ asset.packageNumber || '-' }}</td>
				<td>{{ asset.assetCode || '-' }}</td>
				<td>{{ asset.itemDescription || '-' }}</td>
				<td>{{ asset.itemNumber || '-' }}</td>
				<td>{{ asset.supplierName || '-' }}</td>
				<td style="text-align: center;">
					<ng-container *ngIf="isValidFilePath(asset.fileName); else noFile">
						<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(asset.fileName))"
							[href]="asset.fileName" target="_blank">
							<img [src]="asset.fileName" alt="Preview Image"
								style="width: auto; height: 50px; object-fit: cover;" />
						</a>
						<a *ngIf="getFileExtension(asset.fileName) === 'pdf'" [href]="asset.fileName" target="_blank"
							rel="noopener noreferrer">
							<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
						</a>
						<a *ngIf="getFileExtension(asset.fileName) === 'xlsx'" [href]="asset.fileName" target="_blank"
							rel="noopener noreferrer">
							<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
						</a>
					</ng-container>
					<ng-template #noFile>
						-
					</ng-template>
				</td>
				<td style="text-align: center;">
					<span>
						<ng-container *ngIf="isValidFilePath(asset.invoiceFilePath); else noFile">
							<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(asset.invoiceFilePath))"
								[href]="asset.invoiceFilePath" target="_blank">
								<img [src]="asset.invoiceFilePath" alt="Preview Image"
									style="width: auto; height: 50px; object-fit: cover;" />
							</a>
							<a *ngIf="getFileExtension(asset.invoiceFilePath) === 'pdf'" [href]="asset.invoiceFilePath"
								target="_blank" rel="noopener noreferrer">
								<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
							</a>
							<a *ngIf="getFileExtension(asset.invoiceFilePath) === 'xlsx'" [href]="asset.invoiceFilePath"
								target="_blank" rel="noopener noreferrer">
								<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
							</a>
						</ng-container>


					</span>
				</td>
				<td style="    text-align: center; "> <button (click)="openmodal2(asset.toolLoanMasterId)" pButton
						pRipple type="button" icon="bx bx-download" class="p-button-rounded p-button-text
			p-button-teaxt"></button>
				</td>
				<!-- <td>{{ asset.shiftedDone || '-' }}</td>
				  -->
				<td>
					<!-- New tool: not shifted, not completed -->
					<button *ngIf="!asset.isToolShifted && !asset.shiftedDone" pButton pRipple type="button"
						[label]="'New Tool'" class="p-button-rounded p-button-success status_button"
						style="font-size: 12px; padding: 0.2rem 1rem;">
					</button>

					<!-- Tool marked as shifted but not yet completed -->
					<button *ngIf="asset.isToolShifted && !asset.shiftedDone" pButton pRipple type="button"
						[label]="'New via Shift'" class="p-button-rounded status_button pending"
						style="font-size: 12px; padding: 0.2rem 1rem;">
					</button>

					<!-- Tool shifting is completed -->
					<button *ngIf="asset.shiftedDone" pButton pRipple type="button" [label]="'Tool Transferred'"
						class="p-button-rounded p-button-danger status_button"
						style="font-size: 12px; padding: 0.2rem 1rem;">
					</button>
				</td>

				<td>{{asset.orderNumber || '-'}}</td>
				<td>{{getSafeFormattedDate(asset?.date)}}</td>
				<td>
					<button pButton pRipple type="button" *ngIf="asset.checker1Status== 'Approved'" [label]="'Approved'"
						class="p-button-rounded
						p-button-success status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="asset.checker1Status == 'Pending'" [label]="'Pending'"
						class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="asset.checker1Status == 'Rework'" [label]="'Rework'"
						class="p-button-rounded
						p-button-info status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
				</td>
				<td *ngIf="asset.checker1Status === 'Rework'; else approvedBlock">
					{{ asset.rejectedRemark || '-' }}
				</td>
				<ng-template #approvedBlock>
					<td>{{ asset.approvedRemark || '-' }}</td>
				</ng-template>
				<td>
					<button pButton pRipple type="button" *ngIf="asset.checker2Status== 'Approved'" [label]="'Approved'"
						class="p-button-rounded
						p-button-success status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<!-- <button pButton pRipple type="button" *ngIf="asset.checker2Status == 'Pending'" [label]="'Pending'"
						class="p-button-rounded
						status_button pending" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button> -->
					<ng-container *ngIf="asset.checker2Status === 'Pending'">

						<!-- Show button for checker2 role -->
						<button *ngIf="isChecker2" pButton pRipple type="button" label="Pending"
							class="p-button-rounded status_button pending"
							style="font-size: 12px; padding: 0.2rem 1rem;">
						</button>

						<!-- Show link for checker1 role -->
						<a *ngIf="isChecker1" href="javascript:void(0)" (click)="checker2send(asset)">
							Send to Checker2
						</a>

					</ng-container>
					<button pButton pRipple type="button" *ngIf="asset.checker2Status == 'Rework'" [label]="'Rework'"
						class="p-button-rounded
						p-button-info status_button" style="font-size:
						12px; padding:
						0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="asset.checker2Status == 'pending from checker2'"
						label="Approval Pending" class="p-button-rounded status_button pending"
						style="font-size: 12px; padding: 0.2rem 1rem;">
					</button>
				</td>
				<td *ngIf="asset.checker2Status==='Rework';else checker2approve">{{asset.rejectedRemarkChecker ||'-'}}
				</td>
				<ng-template #checker2approve>
					<td>{{ asset.approvedRemarkChecker || '-' }}</td>
				</ng-template>
				<td>
					<button pButton pRipple type="button" *ngIf="asset.checker3Status === 1" [label]="'Approved'"
						class="p-button-rounded p-button-success status_button"
						style="font-size: 12px; padding: 0.2rem 1rem;"></button>
					<ng-container *ngIf="asset.checker3Status === 0">

						<!-- Show button for checker3 role -->
						<button *ngIf="isChecker3" pButton pRipple type="button" label="Pending"
							class="p-button-rounded status_button pending"
							style="font-size: 12px; padding: 0.2rem 1rem;">
						</button>

						<!-- Show hyphen for checker2 role -->
						<span *ngIf="isChecker2">-</span>

					</ng-container>
					<button pButton pRipple type="button" *ngIf="asset.checker3Status === 2" [label]="'Rework'"
						class="p-button-rounded p-button-info status_button"
						style="font-size: 12px; padding: 0.2rem 1rem;"></button>
					<button pButton pRipple type="button" *ngIf="asset.checker3Status === 3" [label]="'Rejected'"
						class="p-button-rounded p-button-danger status_button"
						style="font-size: 12px; padding: 0.2rem 1rem;"></button>
				</td>
				<td *ngIf="asset.checker3Status === 2 || asset.checker3Status === 3;else checker3approve">
					{{asset.checker3RejectRemark ||'-'}}
				</td>
				<ng-template #checker3approve>
					<td>{{ asset.checker3ApprovedRemark || '-' }}</td>
				</ng-template>
				<td class="status" style="text-align: center;">
					<span class="product-badge status-Acknowledged" *ngIf="asset.documentSigned === true">Signed</span>
					<span class="product-badge status-" *ngIf="asset.documentSigned === false">Not Signed</span>
				</td>
				<!-- <td class="status" style="text-align: center;">
					<span class="product-badge status-Acknowledged"
						*ngIf="asset.documentsInserted === true">Uploaded</span>
					<span class="product-badge status-" *ngIf="asset.documentsInserted === false">Pending</span>
				</td> -->
				<td class="status" style="text-align: center;">
					<span class="product-badge status-Acknowledged"
						*ngIf="asset.invoiceUploaded === true">Uploaded</span>
					<span class="product-badge status-" *ngIf="asset.invoiceUploaded === false">Pending</span>
				</td>
				<!-- <td style="text-align: center;">
					<ng-container *ngIf="isValidFilePath(asset.fileName); else noFile">
						<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(asset.fileName))"
							[href]="asset.fileName" target="_blank">
							<img [src]="asset.fileName" alt="Preview Image"
								style="width: auto; height: 50px; object-fit: cover;" />
						</a>
						<a *ngIf="getFileExtension(asset.fileName) === 'pdf'" [href]="asset.fileName" target="_blank"
							rel="noopener noreferrer">
							<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
						</a>
						<a *ngIf="getFileExtension(asset.fileName) === 'xlsx'" [href]="asset.fileName" target="_blank"
							rel="noopener noreferrer">
							<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
						</a>
					</ng-container>
					<ng-template #noFile>
						-
					</ng-template>
				</td>
				<td style="text-align: center;">
					<span>
						<ng-container *ngIf="isValidFilePath(asset.invoiceFilePath); else noFile">
							<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(asset.invoiceFilePath))"
								[href]="asset.invoiceFilePath" target="_blank">
								<img [src]="asset.invoiceFilePath" alt="Preview Image"
									style="width: auto; height: 50px; object-fit: cover;" />
							</a>
							<a *ngIf="getFileExtension(asset.invoiceFilePath) === 'pdf'" [href]="asset.invoiceFilePath"
								target="_blank" rel="noopener noreferrer">
								<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
							</a>
							<a *ngIf="getFileExtension(asset.invoiceFilePath) === 'xlsx'" [href]="asset.invoiceFilePath"
								target="_blank" rel="noopener noreferrer">
								<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
							</a>
						</ng-container>


					</span>
				</td>
				<td style="    text-align: center; "> <button (click)="openmodal2(asset.toolLoanMasterId)" pButton
						pRipple type="button" icon="bx bx-download" class="p-button-rounded p-button-text
			p-button-teaxt"></button>
				</td> -->
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="10">No data found.</td>
			</tr>
		</ng-template>
	</p-table>




	<div class="flex-grow-1"></div>


	<app-copyrights></app-copyrights>


</div>
<!-- End Main Content Wrapper Area -->


<p-dialog header="Package Wise Detail" [(visible)]="packagewisedetail" [modal]="true" [style]="{width: '85vw'}"
	[draggable]="false" [resizable]="false">

	<div class="add-listings-box-breakup extra-wallet">
		<div class="row">
			<div class="col-lg-4 col-md-12 form-group">
				<label for="city">BU</label>
				<input class="form-control" disabled [value]="packagedatabyid[0]?.bu" minlength="10" maxlength="10"
					autocomplete="off" />
			</div>
			<div class="col-lg-4 col-md-12 form-group">
				<label for="city">Business Unit</label>
				<input class="form-control" disabled [value]="packagedatabyid[0]?.businessUnit" minlength="10"
					maxlength="10" autocomplete="off" />
			</div>
			<div class="col-lg-4 col-md-12 form-group">
				<label for="email">Po Number<span class="star_class">*</span></label>
				<input class="form-control" disabled [value]="packagedatabyid[0]?.orderNumber" minlength="10"
					maxlength="10" autocomplete="off" />
			</div>
			<!-- <div class="col-lg-4 col-md-12 form-group">
				<label for="email">Po Number<span class="star_class">*</span></label>
				<input class="form-control"   disabled
					 minlength="10" maxlength="10" autocomplete="off" />
			</div>

			<div class="col-lg-4 col-md-12 form-group">
				<label for="email">Po Type<span class="star_class">*</span></label>
				<input class="form-control"   disabled
					  minlength="10" maxlength="10" autocomplete="off" />
			</div> -->
			<div class="col-lg-4 col-md-12 form-group">
				<label for="email">Supplier Name<span class="star_class">*</span></label>
				<input class="form-control" disabled [value]="packagedatabyid[0]?.supplierName" minlength="10"
					maxlength="10" autocomplete="off" />
			</div>
			<div class="col-lg-4 col-md-12 form-group">
				<label for="email">Supplier Code<span class="star_class">*</span></label>
				<input class="form-control" disabled [value]="packagedatabyid[0]?.jdecode" minlength="10" maxlength="10"
					autocomplete="off" />
			</div>
			<div class="col-lg-4 col-md-12 form-group">
				<label for="email">Package Number<span class="star_class">*</span></label>
				<input class="form-control" disabled [value]="packagedatabyid[0]?.packageNumber || '-'" minlength="10"
					maxlength="10" autocomplete="off" />
			</div>
			<div class="col-lg-4 col-md-12 form-group">
				<label for="email">Guarantor Name<span class="star_class">*</span></label>
				<input class="form-control" disabled [value]="packagedatabyid[0]?.guaranteeName || '-'" minlength="10"
					maxlength="10" autocomplete="off" />
			</div>
			<div class="col-lg-4 col-md-12 form-group">
				<label for="email">Guarantor Date<span class="star_class">*</span></label>
				<input class="form-control" disabled [value]="getSafeFormattedDate(packagedatabyid[0]?.guaranteeDate)"
					minlength="10" maxlength="10" autocomplete="off" />
			</div>
		</div>
		<h6>Part Details</h6>
		<p-table #dt4 [value]="packagedatabyid" class="mb-2" dataKey="id" responsiveLayout="scroll">
			<ng-template pTemplate="header">
				<tr>
					<th>S.No.</th>
					<th>Po Number</th>
					<th>Po Type</th>
					<th>Part Description</th>
					<th>Part Number</th>
					<th>Tool New Or Shifted</th>
					<th>Tool Type </th>
					<th>Asset Code </th>
					<th>Remark</th>
					<th>Tool Image</th>
					<th>Invoice Document</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-customer let-i="rowIndex">
				<tr>
					<td>{{i+1}}</td>
					<td>
						<span>
							{{customer?.orderNumber}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.poType}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.itemDescription}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.itemNumber}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.toolType}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.capital || '-'}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.assetCode || '-'}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.remark || '-'}}
						</span>
					</td>
					<td><span><a [href]="customer.fileName" target="_blank"
								[download]="customer.fileName">Preview</a></span></td>
					<td><span><a [href]="customer.invoiceFilePath" target="_blank"
								[download]="customer.invoiceFilePath">Preview</a></span></td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="5">No item found.</td>
				</tr>
			</ng-template>
		</p-table>

	</div>

</p-dialog>







<p-dialog [header]="this.header" [(visible)]="displayToolLoan" [modal]="true" [style]="{width: '85vw'}"
	[draggable]="false" [resizable]="false">


	<!-- <div class=""> -->
	<div class="add-listings-box-breakup extra-wallet">
		<h6>Part Details</h6>
		<p-table #dt4 [value]="itemDetails" class="mb-2" dataKey="id" responsiveLayout="scroll">
			<ng-template pTemplate="header">
				<tr>
					<th>S.No.</th>
					<th>Part Number</th>
					<th>Part Description</th>
					<th>
						Material of Construction
					</th>
					<th>Material Remark</th>
					<th>
						Raw Part Weight (Kg)
					</th>
					<th>
						Finish Part Weight (Kg)
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-customer let-i="rowIndex">
				<tr>
					<td>{{i+1}}</td>
					<td>
						<span>
							{{customer?.itemName}}
						</span>
					</td>
					<td>
						<span>
							{{customer?.itemDesc}}
						</span>
					</td>
					<td>
						<span class="image-text">
							{{customer?.materialofconstructionList}}
						</span>
					</td>
					<td>
						<span class="image-text">
							{{customer?.materialRemark ? customer?.materialRemark : '-'}}
						</span>
					</td>
					<td>
						<span class="image-text">
							{{customer?.rawPartWeight}}kg
						</span>
					</td>
					<td>
						<span class="image-text">
							{{customer?.finishPartWeight}}kg
						</span>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="5">No item found.</td>
				</tr>
			</ng-template>
		</p-table>


		<div class="row my-3">
			<div class="col-lg-4 form-group">
				<label for>Sample Document</label>
				<label for>
					<a [href]="this.allData?.documentfileName">Document Preview</a>
				</label>
			</div>
			<div class="col-lg-4 form-group">
				<label for>
					Uploaded Signed Document
				</label>
				<label *ngIf="this.allData?.signedDocument" for>
					<a [href]="this.allData?.signedDocument">
						Uploaded
						Document
					</a>
				</label>
				<p *ngIf="!this.allData?.signedDocument && roleName != 'Supplier'" style="margin-left: 70px;">
					<span>-</span>
				</p>
				<p>
					<span *ngIf="!this.allData?.signedDocument && roleName == 'Supplier'">
						<input (change)="upload_doc($event , 'signed_doc')" type="file" class="form-control">
					</span>
				</p>
			</div>
			<div class="col-lg-3 form-group">
				<label for>FAA Report</label>
				<label *ngIf="this.allData?.faaDocument" for>
					<a [href]="this.allData?.faaDocument" target="_blank">
						Uploaded Document
					</a>
				</label>
				<input #faaDocument *ngIf="!this.allData?.faaDocument && roleName != 'Supplier'"
					(change)="upload_doc($event , 'faaDocument')" type="file" class="form-control">
				<span *ngIf="!this.allData?.faaDocument && roleName == 'Supplier'">-</span>
			</div>
		</div>
		<p-table #dt3 [value]="toolData" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50]"
			[paginator]="false" dataKey="id" responsiveLayout="scroll" currentPageReportTemplate="Showing
            {first} to {last} of {totalRecords} entries">
			<ng-template pTemplate="header">
				<tr>
					<th>S. No.</th>
					<th>Tool Name</th>
					<th>Amount</th>
					<th>Tool Document</th>
					<th *ngIf="roleName == 'Supplier'">Action</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-customer let-i="rowIndex">
				<tr class="earnings-box">
					<td>{{i+1}}</td>
					<td class="form-group">
						<span class="form-control">
							{{customer.toolLoanAgreementName}}
						</span>
					</td>
					<td>
						<div style="display: flex;">
							<input [(ngModel)]="partDetails.cond2" [disabled]="true" type="text" class="form-control"
								style="width: 80px; border-radius: 5px;
                                line-height : 22px; display: flex; align-items:
                                center; border-right: none!important;
                                border-bottom-right-radius: 0;
                                border-top-right-radius: 0;">
							<input [(ngModel)]="customer.toolLoanAgreementAmount" [disabled]="true" pKeyFilter="money"
								type="text" class="form-control" style="border-left: none!important; width:
                                150px;
                                border-top-left-radius: 0;
                                border-top-right-radius: 5px;
                                border-bottom-right-radius: 5px;
                                border-bottom-left-radius: 0">
						</div>
					</td>
					<td>
						<span *ngIf="!customer.isActive" class="form-group">
							<span *ngIf="roleName != 'Supplier' && !customer?.isActive">-</span>
							<span *ngIf="roleName == 'Supplier'">
								<input *ngIf="!customer?.isActive" (change)="upload_doc($event , 'toolDoc' , i)"
									type="file" class="form-control" multiple>
							</span>
						</span>
						<span *ngIf="customer.isActive">
							<span (click)="getImages(customer)" style="text-decoration: underline; cursor: pointer;">
								Preview
							</span>
						</span>
					</td>
					<td *ngIf="roleName == 'Supplier'">
						<button (click)="getToolDoc(i)" pButton pRipple type="button" label="Submit"
							class="p-button-rounded p-button-primary p-button-text"></button>
					</td>
				</tr>
				<tr *ngIf="i == toolData.length-1">
					<td></td>
					<td style="font-size: 15px;">
						<b>Total Tools Amount</b>
					</td>
					<td>
						<div style="display: flex; ">
							<input [disabled]="true" [(ngModel)]="partDetails.cond2" type="text" class="form-control"
								style="width:
                                80px; border-radius: 5px; line-height : 22px;
                                display: flex; align-items: center;
                                border-right: none!important;
                                border-bottom-right-radius: 0;
                                border-top-right-radius: 0;">
							<input [(ngModel)]="rfqToolTotal" [disabled]="true" pKeyFilter="money" type="text"
								class="form-control" style="border-left:
                                none!important; width: 150px;
                                border-top-left-radius: 0;
                                border-top-right-radius: 5px;
                                border-bottom-right-radius: 5px;
                                border-bottom-left-radius: 0">
						</div>
					</td>
					<td></td>
					<td></td>
				</tr>
			</ng-template>
		</p-table>
	</div>


	<div class="add-listings-btn col-lg-4 col-md-6">
		<div class="form-group">
			<button (click)="submitFAAImages()" type="submit" class="submit_btn">
				Submit
			</button>
		</div>
	</div>
</p-dialog>


<p-dialog header="Upload Invoice" [(visible)]="display" [modal]="true" [style]="{width: '35vw'}" [draggable]="false"
	[resizable]="false" (onHide)="resetform()">
	<form [formGroup]="toolLoanForm" (ngSubmit)="submitForm()" #register="ngForm">
		<div class="add-listings-box1">
			<div class="row">
				<div class="col-lg-6 col-md-12 form-group">
					<label>Upload Invoice<span class="star_class">*</span></label>
					<input #fileInput type="file" class="form-control" formControlName="uploadDoc" [class.is-invalid]="(register.submitted &&
					 toolLoanForm.get('uploadDoc')?.invalid) ||
					 (toolLoanForm.get('uploadDoc')?.touched &&
					 toolLoanForm.get('uploadDoc')?.invalid)" (change)="getFile($event)" required>
					<div class="invalid-feedback">Please Upload Document</div>

				</div>

			</div>
			<div class="form-group">
				<button type="submit" class="submit_btn">Upload</button>

			</div>
		</div>
	</form>
</p-dialog>



<p-dialog [style]="{'width' : '50vw'}" [(visible)]="displayImages" [modal]="true" [draggable]="false"
	[resizable]="false" header="Tool Name : {{toolName}}">
	<ng-container *ngFor="let drawing of toolImages; let index = index">
		<span style="font-size: 12px;" class="mx-2">
			{{index+1}}.
		</span>
		<a [href]="drawing.value" [download]="drawing.value" style="font-size: 12px;" target="_blank">
			{{_utility.getDrawingName(drawing.value)}}
		</a>
		<span *ngIf="roleName == 'Supplier'" (click)="deleteImage(drawing)" pToolTip="Delete Tool Image"
			style="cursor: pointer;">
			x
		</span>
		<br>
	</ng-container>
</p-dialog>
<p-dialog header="Actions" [breakpoints]="{'850px' : '90vw'}" [(visible)]="approveModalState" [modal]="true" appendTo="body"
	[style]="{ width: '80vw' }" [baseZIndex]="10001" [draggable]="false" (onHide)="resetApprovalForm()"
	[resizable]="false" [closable]="true" [closeOnEscape]="true">
	<div class="add-listings-box">
		<form [formGroup]="approvalForm" (ngSubmit)="onSubmit(form)" #form="ngForm">

			<p-table #dt4 [value]="packagedatabyid" class="mb-2" dataKey="id" responsiveLayout="scroll">
				<ng-template pTemplate="header">
					<tr>
						<th>S.No.</th>
						<th>Po Number</th>
						<th>Po Type</th>
						<th>Part Description</th>
						<th>Part Number</th>
						<th>Tool New Or Shifted</th>
						<th>Tool Type </th>
						<th>Asset Code </th>
						<th>Remark</th>
						<th>Photos</th>
						<th>Invoice</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-customer let-i="rowIndex">
					<tr>
						<td>{{i+1}}</td>
						<td>
							<span>
								{{customer?.orderNumber}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.poType}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.itemDescription}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.itemNumber}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.toolType}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.capital || '-'}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.assetCode || '-'}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.remark || '-'}}
							</span>
						</td>
						<td>
							<ng-container *ngIf="isValidFilePath(customer.fileName); else unknownFile">
								<!-- Image Preview -->
								<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(customer.fileName))"
									[href]="customer.fileName" target="_blank">
									<img [src]="customer.fileName" alt="Preview Image"
										style="width: auto; height: 50px; object-fit: cover;" />
								</a>

								<!-- PDF Icon -->
								<a *ngIf="getFileExtension(customer.fileName) === 'pdf'" [href]="customer.fileName"
									target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
								</a>

								<!-- Excel Icon -->
								<a *ngIf="getFileExtension(customer.fileName) === 'xlsx'" [href]="customer.fileName"
									target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
								</a>
							</ng-container>

							<!-- Show generic icon for unknown file types -->
							<ng-template #unknownFile>
								<a *ngIf="customer.fileName" [href]="customer.fileName" target="_blank"
									rel="noopener noreferrer">
									<i class="pi pi-file" style="font-size: 32px !important; color: blue;"></i>
								</a>
								<span *ngIf="!customer.fileName">-</span>
							</ng-template>
						</td>

						<td>
							<ng-container *ngIf="isValidFilePath(customer.invoiceFilePath); else noFile">
								<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(customer.invoiceFilePath))"
									[href]="customer.invoiceFilePath" target="_blank">
									<img [src]="customer.invoiceFilePath" alt="Invoice Preview"
										style="width: auto; height: 50px; object-fit: cover;" />
								</a>
								<a *ngIf="getFileExtension(customer.invoiceFilePath) === 'pdf'"
									[href]="customer.invoiceFilePath" target="_blank">
									<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
								</a>
								<a *ngIf="getFileExtension(customer.invoiceFilePath) === 'xlsx'"
									[href]="customer.invoiceFilePath" target="_blank">
									<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
								</a>
								<a *ngIf="['doc', 'docx'].includes(getFileExtension(customer.invoiceFilePath))"
									[href]="customer.invoiceFilePath" target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file" style="font-size: 32px !important; color: blue;"></i>
								</a>
							</ng-container>
							<ng-template #noFile>
								<input type="file" class="form-control"
									(change)="upload_doc($event, 'checker_invoice',i)" />
							</ng-template>
						</td>



					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="5">No item found.</td>
					</tr>
				</ng-template>
			</p-table>
			<div class="row" *ngIf="role.roleName === 'Admin' ||  role.checker1==true">
				<div class="col-lg-4 col-md-12 form-group">
					<label>
						Remark/Reason<span class="star_class">*</span>:</label>
					<textarea type="text" placeholder="Remark/Reason" formControlName="ApprovedRemark"
						class="form-control mb-3" [class.is-invalid]="
              (form.submitted && approvalForm.get('ApprovedRemark')?.invalid) ||
              (approvalForm.get('ApprovedRemark')?.invalid &&
                approvalForm.get('ApprovedRemark').touched)
                 ">
                </textarea>
					<div class="invalid-feedback" style="margin-top: 1.25rem">
						Remark/Reason is Required
					</div>
					<!-- <hr> -->
				</div>
				<div class="col-lg-4 col-md-12 form-group">
					<label>Car No/Approval<span class="star_class">*</span></label>
					<input class="form-control" type="text" formControlName="Carno" placeholder="Enter Car No."
						autocomplete="off" [class.is-invalid]="(statusString === 'approve') && form.submitted &&
                        approvalForm.get('Carno')?.invalid ||
                        approvalForm.get('Carno')?.invalid &&
                        approvalForm.get('Carno')?.touched" />
					<div class="invalid-feedback">
						Car No. is Required </div>
				</div>
				<div class="col-lg-4 col-md-12 form-group">
					<label>Car Upload<span class="star_class">*</span></label>
					<input class="form-control" type="file" formControlName="Carupload" #Carupload
						(change)="upload_doc($event,'car_upload')" autocomplete="off" [class.is-invalid]="(statusString === 'approve') &&  	form.submitted &&
                        approvalForm.get('Carupload')?.invalid ||
                        approvalForm.get('Carupload')?.invalid &&
                        approvalForm.get('Carupload')?.touched" />
					<div class="invalid-feedback">
						Car Upload is Required </div>
				</div>
				<div *ngIf="existingCarUploadUrl" class="mt-2">
					<a [href]="existingCarUploadUrl" target="_blank">View previous Car Upload File</a>
				</div>
			</div>
			<div class="col-lg-12">
				<div class="add-listings-btn" style="text-align: right">
					<button class="mr-2 success-btn" type="submit" (click)="btnClick('approve')"
						style="background: #40b340; color: white;">
						Approve
					</button>
					<button class="mr-2 reject-btn" type="submit" (click)="btnClick('reject')"
						style="background: #e34747; color: white;">
						Rework
					</button>
				</div>
			</div>

		</form>
	</div>

</p-dialog>
<p-dialog header="Actions" [breakpoints]="{'850px' : '90vw'}" [(visible)]="checker2ModalState" [modal]="true" appendTo="body"
	[style]="{ width: '80vw' }" [baseZIndex]="10001" [draggable]="false" (onHide)="resetApprovalForm()"
	[resizable]="false" [closable]="true" [closeOnEscape]="true">
	<div class="add-listings-box">
		<form [formGroup]="checker2approvalform" (ngSubmit)="checker2approval(form)" #form="ngForm">

			<p-table #dt4 [value]="packagedatabyid" class="mb-2" dataKey="id" responsiveLayout="scroll">
				<ng-template pTemplate="header">
					<tr>
						<th>S.No.</th>
						<th>Po Number</th>
						<th>Po Type</th>
						<th>Part Description</th>
						<th>Tool New Or Shifted</th>
						<th>Tool Type </th>
						<th>Asset Code </th>
						<th>Remark</th>
						<th>Photos</th>
						<th>Invoice</th>
						<th>Agreement</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-customer let-i="rowIndex">
					<tr>
						<td>{{i+1}}</td>
						<td>
							<span>
								{{customer?.orderNumber}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.poType}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.itemDescription}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.toolType}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.capital || '-'}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.assetCode || '-'}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.remark || '-'}}
							</span>
						</td>
						<td>
							<ng-container *ngIf="isValidFilePath(customer.fileName); else temp">
								<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(customer.fileName))"
									[href]="customer.fileName" target="_blank">
									<img [src]="customer.fileName" alt="Preview Image"
										style="width: auto; height: 50px; object-fit: cover;" />
								</a>
								<a *ngIf="getFileExtension(customer.fileName) === 'pdf'" [href]="customer.fileName"
									target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
								</a>
								<a *ngIf="getFileExtension(customer.fileName) === 'xlsx'" [href]="customer.fileName"
									target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
								</a>
								<a *ngIf="['doc', 'docx'].includes(getFileExtension(customer.fileName))"
									[href]="customer.fileName" target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file" style="font-size: 32px !important; color: blue;"></i>
								</a>
							</ng-container>
							<ng-template #temp>
								-
							</ng-template>
						</td>
						<td>
							<ng-container *ngIf="isValidFilePath(customer.invoiceFilePath); else noFile">
								<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(customer.invoiceFilePath))"
									[href]="customer.invoiceFilePath" target="_blank">
									<img [src]="customer.invoiceFilePath" alt="Invoice Preview"
										style="width: auto; height: 50px; object-fit: cover;" />
								</a>
								<a *ngIf="getFileExtension(customer.invoiceFilePath) === 'pdf'"
									[href]="customer.invoiceFilePath" target="_blank">
									<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
								</a>
								<a *ngIf="getFileExtension(customer.invoiceFilePath) === 'xlsx'"
									[href]="customer.invoiceFilePath" target="_blank">
									<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
								</a>
								<a *ngIf="['doc', 'docx'].includes(getFileExtension(customer.invoiceFilePath))"
									[href]="customer.invoiceFilePath" target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file" style="font-size: 32px !important; color: blue;"></i>
								</a>
							</ng-container>
							<ng-template #noFile>
								-
							</ng-template>
						</td>
						<td style="text-align: center;">
							<button (click)="openmodal2(packagedatabyid[0]?.toolLoanMasterId)" pButton pRipple
								type="button" icon="bx bx-download"></button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="5">No item found.</td>
					</tr>
				</ng-template>
			</p-table>
			<div class="row">
				<div class="col-lg-4 col-md-12 form-group">
					<label>
						Remark/Reason<span class="star_class">*</span>:</label>
					<textarea type="text" placeholder="Remark/Reason" class="form-control mb-3" readonly
						[value]="packagedatabyid[0]?.approvedRemark">
                </textarea>
				</div>
				<div class="col-lg-4 col-md-12 form-group">
					<label>Car No<span class="star_class">*</span></label>
					<input class="form-control" type="text" placeholder="Enter Car No." autocomplete="off" readonly
						[value]="packagedatabyid[0]?.carNumber" />
				</div>
				<div class="col-lg-4 col-md-12 form-group">
					<label>Car Upload<span class="star_class">*</span></label>
					<span class="form-control"><a [href]="packagedatabyid[0]?.carUploadFilePath" target="_blank"
							[download]="packagedatabyid[0]?.carUploadFilePath">Preview</a></span>
				</div>

				<div class="col-lg-4 col-md-12 form-group">
					<label>
						Remark/Reason<span class="star_class">*</span>:</label>
					<textarea type="text" placeholder="Remark/Reason" formControlName="checker2remark"
						class="form-control mb-3" [class.is-invalid]="
              (form.submitted && checker2approvalform.get('checker2remark')?.invalid) ||
              (checker2approvalform.get('checker2remark')?.invalid &&
                checker2approvalform.get('checker2remark').touched)
                 ">
				 </textarea>
					<div class="invalid-feedback" style="margin-top: 1.25rem">
						Remark/Reason is Required
					</div>
				</div>
				<div class="col-lg-4 col-md-12 form-group" *ngIf="statusString === 'reject'">
					<label>
						Send Rework To <span class="star_class">*</span>:
					</label>
					<select formControlName="reworkTo" class="form-control form-select" [class.is-invalid]="
      (form.submitted && checker2approvalform.get('reworkTo')?.invalid) ||
      (checker2approvalform.get('reworkTo')?.invalid &&
        checker2approvalform.get('reworkTo').touched)
    ">
						<option value="" disabled selected>Select Recipient</option>
						<option value="Supplier">Supplier</option>
						<option value="Checker1">Checker 1</option>
					</select>
					<div class="invalid-feedback">
						Please select whom to send for rework
					</div>
				</div>

			</div>
			<div class="col-lg-12">
				<div class="add-listings-btn" style="text-align: right">
					<button class="mr-2 success-btn" type="submit" (click)="btnClick('approve')"
						style="background: #40b340; color: white;">
						Approve
					</button>
					<button class="mr-2 reject-btn" type="submit" (click)="btnClick('reject')"
						style="background: #e34747; color: white;">
						Rework
					</button>
				</div>
			</div>

		</form>
	</div>

</p-dialog>
<p-dialog header="Actions" [breakpoints]="{'850px' : '90vw'}" [(visible)]="checker3ModalState" [modal]="true" appendTo="body"
	[style]="{ width: '80vw' }" [baseZIndex]="10001" [draggable]="false" (onHide)="resetApprovalForm()" 
	[resizable]="false" [closable]="true" [closeOnEscape]="true">
	<div class="add-listings-box">
		<form [formGroup]="checker3approvalform" (ngSubmit)="checker3approval(form)" #form="ngForm">

			<p-table #dt4 [value]="packagedatabyid" class="mb-2" dataKey="id" responsiveLayout="scroll">
				<ng-template pTemplate="header">
					<tr>
						<th>S.No.</th>
						<th>Po Number</th>
						<th>Po Type</th>
						<th>Part Description</th>
						<th>Tool New Or Shifted</th>
						<th>Tool Type </th>
						<th>Asset Code </th>
						<th>Remark</th>
						<th>Photos</th>
						<th>Invoice</th>
						<th>Agreement</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-customer let-i="rowIndex">
					<tr>
						<td>{{i+1}}</td>
						<td>
							<span>
								{{customer?.orderNumber}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.poType}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.itemDescription}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.toolType}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.capital || '-'}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.assetCode || '-'}}
							</span>
						</td>
						<td>
							<span>
								{{customer?.remark || '-'}}
							</span>
						</td>
						<td>
							<ng-container *ngIf="isValidFilePath(customer.fileName); else temp">
								<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(customer.fileName))"
									[href]="customer.fileName" target="_blank">
									<img [src]="customer.fileName" alt="Preview Image"
										style="width: auto; height: 50px; object-fit: cover;" />
								</a>
								<a *ngIf="getFileExtension(customer.fileName) === 'pdf'" [href]="customer.fileName"
									target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
								</a>
								<a *ngIf="getFileExtension(customer.fileName) === 'xlsx'" [href]="customer.fileName"
									target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
								</a>
								<a *ngIf="['doc', 'docx'].includes(getFileExtension(customer.fileName))"
									[href]="customer.fileName" target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file" style="font-size: 32px !important; color: blue;"></i>
								</a>
							</ng-container>
							<ng-template #temp>
								-
							</ng-template>
						</td>
						<td>
							<ng-container *ngIf="isValidFilePath(customer.invoiceFilePath); else noFile">
								<a *ngIf="['jpg','jpeg','png'].includes(getFileExtension(customer.invoiceFilePath))"
									[href]="customer.invoiceFilePath" target="_blank">
									<img [src]="customer.invoiceFilePath" alt="Invoice Preview"
										style="width: auto; height: 50px; object-fit: cover;" />
								</a>
								<a *ngIf="getFileExtension(customer.invoiceFilePath) === 'pdf'"
									[href]="customer.invoiceFilePath" target="_blank">
									<i class="pi pi-file-pdf" style="font-size: 32px !important; color: red;"></i>
								</a>
								<a *ngIf="getFileExtension(customer.invoiceFilePath) === 'xlsx'"
									[href]="customer.invoiceFilePath" target="_blank">
									<i class="pi pi-file-excel" style="font-size: 32px !important; color: green;"></i>
								</a>
								<a *ngIf="['doc', 'docx'].includes(getFileExtension(customer.invoiceFilePath))"
									[href]="customer.invoiceFilePath" target="_blank" rel="noopener noreferrer">
									<i class="pi pi-file" style="font-size: 32px !important; color: blue;"></i>
								</a>
							</ng-container>
							<ng-template #noFile>
								-
							</ng-template>
						</td>
						<td style="text-align: center;">
							<button (click)="openmodal2(packagedatabyid[0]?.toolLoanMasterId)" pButton pRipple
								type="button" icon="bx bx-download"></button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="5">No item found.</td>
					</tr>
				</ng-template>
			</p-table>
			<div class="row">
				<div class="col-lg-4 col-md-12 form-group">
					<label>
						Remark/Reason<span class="star_class">*</span>:</label>
					<textarea type="text" placeholder="Remark/Reason" class="form-control mb-3" readonly
						[value]="packagedatabyid[0]?.approvedRemark">
                </textarea>
				</div>
				<div class="col-lg-4 col-md-12 form-group">
					<label>Car No<span class="star_class">*</span></label>
					<input class="form-control" type="text" placeholder="Enter Car No." autocomplete="off" readonly
						[value]="packagedatabyid[0]?.carNumber" />
				</div>
				<div class="col-lg-4 col-md-12 form-group">
					<label>Car Upload<span class="star_class">*</span></label>
					<span class="form-control"><a [href]="packagedatabyid[0]?.carUploadFilePath" target="_blank"
							[download]="packagedatabyid[0]?.carUploadFilePath">Preview</a></span>
				</div>

				<div class="col-lg-4 col-md-12 form-group">
					<label>
						Remark/Reason<span class="star_class">*</span>:</label>
					<textarea type="text" placeholder="Remark/Reason" formControlName="checker3remark"
						class="form-control mb-3" [class.is-invalid]="
              (form.submitted && checker3approvalform.get('checker3remark')?.invalid) ||
              (checker3approvalform.get('checker3remark')?.invalid &&
                checker3approvalform.get('checker3remark').touched)
                 ">
				 </textarea>
					<div class="invalid-feedback" style="margin-top: 1.25rem">
						Remark/Reason is Required
					</div>
				</div>
				<div class="col-lg-4 col-md-12 form-group" *ngIf="statusString === 'reject'">
					<label>
						Send Rework To <span class="star_class">*</span>:
					</label>
					<select formControlName="reworkTo" class="form-control form-select" [class.is-invalid]="
      (form.submitted && checker3approvalform.get('reworkTo')?.invalid) ||
      (checker3approvalform.get('reworkTo')?.invalid &&
        checker3approvalform.get('reworkTo').touched)
    ">
						<option value="" disabled selected>Select Recipient</option>
						<option value="Supplier">Supplier</option>
						<option value="Checker1">Checker 1</option>
					</select>
					<div class="invalid-feedback">
						Please select whom to send for rework
					</div>
				</div>

			</div>
			<div class="col-lg-12">
				<div class="add-listings-btn" style="text-align: right">
					<button class="mr-2 success-btn" type="submit" (click)="btnClick('approve')"
						style="background: #40b340; color: white;">
						Approve
					</button>
					<button class="mr-2 reject-btn" type="submit" (click)="btnClick('reject')"
						style="background: #e34747; color: white;">
						Rework
					</button>
				</div>
			</div>

		</form>
	</div>

</p-dialog>
<p-dialog header="Package Wise Detail" [(visible)]="agreementdetail" [modal]="true" [style]="{width: '85vw'}"
	[draggable]="false" [resizable]="false">

	<div #dataToExport>

		<head>
			<meta http-equiv="Content-Type" content="text/html; charset=iso-8859-1" />
			<title>Untitled Document</title>
		</head>
		<style>
			body {
				margin: 4% 5%;
				margin-top: 0px !important;
				font-size: 12px !important;
			}

			.borderNone {
				border: none !important;
			}

			table {
				margin: 30px 0;
				color: #0033ff;
				border-collapse: collapse;
			}

			table tr td {
				padding-left: 7px;
			}

			.table2 {
				margin: auto;
			}

			.table2tr {
				height: 1.5rem;
			}

			td {
				border: 1px solid black;
				border-collapse: collapse;
			}

			.firstPageTable {
				width: 100%;
			}

			.firstPageTableRowOne,
			firstPageTableRowThree {
				width: 20%;
			}

			.firstPageTableRowTwo {
				width: 60%;
			}

			.textColorBlue {
				color: #0066ff;
			}

			.style7 {
				color: #0066ff;
				font-weight: bold;
				font-size: 18px;
			}
		</style>

		<body>
			<br />
			<br />
			<br />
			<div align="center" style="font-size: 14px; font-weight: bold">
				SUPPLIER TOOLING LOAN AGREEMENT
			</div>
			<table class="firstPageTable">
				<tr>
					<td rowspan="2" class="firstPageTableRowOne">
						<strong class="textColorBlue">Supplier</strong>
					</td>
					<!-- <td rowspan="2" class="firstPageTableRowTwo">
						 {{ supplierdata[0]?.supplierName }} {{ suppplierAddress }}
					</td> -->
					<!-- <td rowspan="2" class="firstPageTableRowTwo">
  {{ supplierdata[0]?.supplierName && (supplierdata[0]?.supplierName + ' ' +supplierdata[0]?.suppplierAddress) }}
</td> -->
					<td rowspan="2" class="firstPageTableRowTwo">
						{{ supplierdata[0]?.supplierName }},{{ supplierdata[0]?.supplierAddress }}
					</td>
					<td class="firstPageTableRowThree">
						<span class="textColorBlue"><strong>IDEX Supplier No.</strong></span>
					</td>
				</tr>
				<tr>
					<td>
						<span class="textColorBlue"><strong>{{supplierdata[0]?.jdecode}}</strong></span>
					</td>
				</tr>
			</table>
			<p>
				<strong>
					One or more Units of IDEX Corporation (collectively IDEX) may from time
					to time loan to the Supplier named above and/or its Subcontractor or
					Subcontractors named below the use of Tooling owned by IDEX for the
					purpose of producing products, components and parts for IDEX.
				</strong>
			</p>
			<p>
				The Tooling being used by the Supplier shall be identified on one or more
				Addendums to this Supplier Tooling Loan Agreement, and the Tooling being
				used by a Subcontractor shall be identified on one or more Addendums to
				the Subcontractor Tooling Loan Agreement with such Subcontractor.
			</p>
			<p>
				All Tooling is and shall remain the sole and exclusive property of IDEX
				and shall be delivered and turned over to IDEX upon demand, whether or not
				any amount is then claimed to be due and owing from IDEX to the Supplier
				or any Subcontractor.
			</p>
			<p>
				While on loan to the Supplier or any Subcontractor: (a) no asset number on
				the Tooling or any asset tag or label that shows the Tooling to be the
				property of IDEX shall be defaced, removed or obscured; (b) the Tooling
				shall be used solely for the purpose of producing products, components or
				parts for IDEX and for no other purpose; (c) the Tooling shall be used
				only by the Supplier or the Subcontractor at its address shown in the
				applicable Addendum; (d) no person or entity other than the Supplier or
				the Subcontractor shall be permitted to use the Tooling; and (e) except
				for limited periods when the Tooling is required to be located elsewhere
				to carry out maintenance and repairs on the Tooling, the Tooling shall be
				kept at all times in the possession of the Supplier or the Subcontractor
				at its address shown in the applicable Addendum.
			</p>
			<p>
				The Supplier acknowledges that (a) the products, components and parts
				produced using the Tooling and the Tooling itself are unique and
				proprietary to IDEX; (b) a requirement that the Tooling be delivered and
				turned over to IDEX upon demand is fair and reasonable; (c) the Tooling
				cannot be readily replaced; and (d) if the Tooling is not delivered and
				turned over to IDEX upon demand: (i) the damages that IDEX would incur
				could be significant and far in excess of the cost of merely obtaining
				replacement Tooling, and (ii) IDEX will be entitled to obtain a court
				order requiring the immediate return of the Tooling to IDEX.
			</p>
			<p>
				The Supplier assumes risk of loss and damage when the Tooling is delivered
				to the Supplier or any Subcontractor and all risk of loss and damage shall
				remain with the Supplier until the Tooling is returned to IDEX. All
				Tooling must be returned to IDEX undamaged, in good condition and repair,
				with all components and parts, normal wear and tear only excepted.
				Notwithstanding anything to the contrary, the Supplier will have no
				obligation with respect to physical defects in the Tooling that existed
				when the Tooling was initially delivered to the Supplier or its
				Subcontractor.
			</p>
			<p>
				The Supplier shall be responsible for the proper and safe installation,
				use, operation, condition, maintenance and deinstallation of the Tooling
				by Supplier and any Subcontractor. Without in any way limiting the
				forgoing: (a) the Supplier shall ensure that all persons who install, use,
				operate, maintain and deinstall the Tooling have the requisite training,
				knowledge, skill and experience to properly and safely install, use,
				operate, maintain and deinstall the Tooling; (b) the Supplier shall ensure
				that the Tooling is installed, used, operated, maintained and deinstalled
				properly and safely in accordance with all applicable instructions and
				directions, all applicable laws, rules and regulations, and best industry
				practices; and (c) the Supplier shall defend, indemnify and hold harmless
				IDEX Corporation and its parent, subsidiary and affiliated companies from
				and against any and all claims, liabilities and obligations for personal
				injury, death or property damage relating to or arising out of the actual
				or alleged improper or unsafe installation, use, operation, maintenance,
				condition or deinstallation of the Tooling or any equipment on which the
				Tooling is installed or with which the Tooling is used; provided, however,
				(i) if and to the extent there are physical defects in the Tooling when
				the Tooling is initially delivered to the Supplier or its Subcontractor,
				the Supplier will have no obligation under this clause (c) with respect to
				any personal injury, death or property damage attributable to physical
				defects in the Tooling that existed when the Tooling was initially
				delivered to the Supplier or its Subcontractor, and (ii) if and to the
				extent the Tooling is based on a design provided by IDEX, the Supplier
				will have no obligation under this clause (c) with respect to any personal
				injury, death or property damage attributable to defects in the design
				provided by IDEX.
			</p>
			<p>
				In addition to all other rights and remedies, IDEX shall be entitled to
				recover from the Supplier all attorneys fees and other costs and expenses
				that IDEX may incur in enforcing this Supplier Tooling Loan Agreement.
			</p>
			<p>
				<strong>Subcontractor or Subcontractors to whom Tooling may be loaned
					<em>(if none, insert None</em>):</strong>
			</p>
			<table width="80%" border="1" align="center" class="table2">
				<tr>
					<td>
						<span class="textColorBlue"><strong>Name</strong></span>
					</td>
					<td>
						<span class="textColorBlue"><strong>Address</strong></span>
					</td>
				</tr>
				<tr class="table2tr">
					<td>{{getSafeTitle(supplierdata[0]?.subName)}}</td>
					<td>&nbsp; {{getSafeTitle(supplierdata[0]?.subAddress)}}</td>
				</tr>
				<tr class="table2tr">
					<td>&nbsp;</td>
					<td>&nbsp;</td>
				</tr>
				<tr class="table2tr">
					<td>&nbsp;</td>
					<td>&nbsp;</td>
				</tr>
			</table>
			<p>
				<strong><em>Each Subcontractor must enter into a Subcontractor Tooling Loan
						Agreement with respect to all Tooling being used by such
						Subcontractor.</em></strong>
			</p>
			<p>
				<strong>The Supplier named above hereby confirms its agreement with and
					acceptance of the above terms and conditions.
				</strong>
			</p>
			<table width="100%" style="border: 1px solid black">
				<tr>
					<td style="padding-top: 20px; position: relative" class="borderNone">
						By: <span style="color: black">{{supplierdata[0]?.supplierName}}</span>
						<span style="
			  position: absolute;
			  top: 23px !important;
			  left: 28px !important; 
			  color: #000000;
			">_____________________________</span>
					</td>
					<!-- <td style="padding-top: 23px; position: relative" class="borderNone">
		  By: 
		  <input 
			type="text"
			style="
			  position: absolute;
			  top: 23px !important;
			  left: 45px !important;
			  width: 200px;
			  border: none;
			  border-bottom: 1px solid black;
			  outline: none;
			  background: transparent;
			"
			placeholder="Enter name"
		  />
		</td> -->
					<td rowspan="4" width="50%" style="color: #000000">
						<p>
							<strong><em>By signing this Agreement, the person signing this Agreement
									warrants and represents that (i) he or she is authorized to sign
									this Agreement on behalf of the Supplier, and (ii) this
									Agreement is a valid, binding and legally enforceable obligation
									of the Supplier in accordance with its terms and conditions.</em></strong>
						</p>
					</td>
				</tr>
				<tr>
					<td class="borderNone" style="padding-top: 23px; position: relative">
						Name: <input type="text" [value]="getSafeTitle(supplierdata[0]?.name)" style="
			position: absolute;
			top: 23px !important;
			left: 45px !important;
			width: 200px;
			border: none;
			border-bottom: 1px solid black;
			outline: none;
			background: transparent;
		  " placeholder="Enter name" />
					</td>
				</tr>
				<tr>
					<td class="borderNone" style="padding-top: 23px; position: relative">
						Title: <input type="text" [value]="getSafeTitle(supplierdata[0]?.title)" style=" 
			position: absolute;
			top: 23px !important;
			left: 45px !important;
			width: 200px;
			border: none;
			border-bottom: 1px solid black;
			outline: none;
			background: transparent;
		  " placeholder="Enter title" />
					</td>
				</tr>
				<tr>
					<td class="borderNone" style="position: relative; padding-bottom: 23px">
						Date: <input type="text" [value]="getSafeFormattedDate(supplierdata[0]?.date)" style="
			position: absolute;
			top: 15px !important;
			left: 45px !important;
			width: 200px;
			border: none;
			border-bottom: 1px solid black;
			outline: none;
			background: transparent;
		  " placeholder="Enter name" />
					</td>
				</tr>
			</table>
			<p align="center"><strong>GUARANTEE</strong></p>
			<p>
				<strong>The undersigned, for the purpose of inducing IDEX to loan to the
					Supplier named above and/or its Subcontractor or Subcontractors named
					above the use of the Tooling and with the understanding that IDEX is
					relying on this Guarantee in loaning to the Supplier named above and/or
					its Subcontractor or Subcontractors named above the use of the Tooling,
					hereby absolutely, unconditionally and irrevocably personally guarantees
					the full, proper and timely performance, satisfaction and discharge of
					all obligations of the Supplier under this Supplier Tooling Loan
					Agreement.</strong>
			</p>
			<p>&nbsp;</p>
			<p>
				<span class="textColorBlue" style="position: relative">
					<strong>
						Name of Guarantor:
						<input type="text" [value]="supplierdata[0]?.guaranteeName" style="  
			  position: absolute;
			  top: -8px;
			  left: 140px;
			  width: 250px; 
			  border: none; 
			  border-bottom: 1px solid black; 
			  outline: none; 
			  background: transparent;
			" placeholder="Enter name" readonly />
					</strong>
				</span>

				<br /><br />

				<!-- <span class="textColorBlue" style="position: relative">
					<strong>
						Signature of Guarantor:
						<span style="color: black; padding-left: 7px"></span>
						<input readonly type="text"
							style="position: absolute; top: -8px; left: 145px; width: 250px; border: none; border-bottom: 1px solid black; outline: none; background: transparent;"
							placeholder="Enter signature" />
					</strong>
					<br /><br />
				</span> -->


				<span class="textColorBlue" style="position: relative">
					<strong>Date:
						<span style="color: black; padding-left: 7px"></span>
						<input readonly [value]="getSafeFormattedDate(supplierdata[0]?.guaranteeDate)" type="text"
							style="
			position: absolute;
			top: -6px !important;
			left: 48px !important;
			width: 200px;
			border: none;
			border-bottom: 1px solid black;
			outline: none;
			background: transparent;
		  " /></strong></span>
			</p>
			<p>
				<em>
					<span style="font-size: 10px">Supplier Tooling Loan Agmt (Nov 2008).doc</span>
				</em>
			</p>
			<p>&nbsp;</p>
			<p align="center">
				<strong>ADDENDUM </strong><br />
				<strong>to</strong><br />
				<strong>SUPPLIER TOOLING LOAN AGREEMENT</strong>
			</p>
			<table width="100%" class="textColorBlue">
				<tr>
					<td width="15%" rowspan="2"><strong>Supplier</strong></td>
					<td width="52%" rowspan="2"> {{ supplierdata[0]?.supplierName }},{{ supplierdata[0]?.supplierAddress
						}}</td>
					<td width="33%"><strong>IDEX Supplier No. </strong></td>
				</tr>
				<tr>
					<td rowsp><strong>{{supplierdata[0]?.jdecode}}</strong></td>
				</tr>
				<tr class="borderNone">
					<td rowspan="2" style="height: 40px">
						<strong>IDEX Unit</strong>
					</td>
					<td rowspan="2">142000
						IDEX INDIA PVT. LTD.
						Survey No. 256, GIDC Manjusar, Savli Near
						Bombardier Circle
						Dist. Vadodara Vadodara GJ 391770</td>
				</tr>
				<tr></tr>
			</table>
			<table width="100%" border="1">
				<tr>
					<td>
						<div align="center"><span class="style7">Tooling</span></div>
					</td>
				</tr>
			</table>
			<div *ngFor="let tool of supplierdata">
				<table width="100%" border="1">
					<tr>
						<td width="67%" rowspan="2">{{ tool.itemDescription }}</td>
						<td width="33%">
							<span class="textColorBlue"><strong>IDEX Asset No. </strong></span>
						</td>
					</tr>
					<tr>
						<td>{{tool.assetCode}}</td>
					</tr>
				</table>
			</div>
			<!-- <table width="100%" border="1">
	  <tr>
		<td width="67%" rowspan="2">-</td>
		<td width="33%">
		  <span class="textColorBlue"><strong>IDEX Asset No. </strong></span>
		</td>
	  </tr>
	  <tr>
		<td>_</td>
	  </tr>
	</table>
	<table width="100%" border="1">
	  <tr>
		<td width="67%" rowspan="2">-</td>
		<td width="33%">
		  <span class="textColorBlue"><strong>IDEX Asset No. </strong></span>
		</td>
	  </tr>
	  <tr>
		<td>_</td>
	  </tr>
	</table>
	<table width="100%" border="1">
	  <tr>
		<td width="67%" rowspan="2">-</td>
		<td width="33%">
		  <span class="textColorBlue"><strong>IDEX Asset No. </strong></span>
		</td>
	  </tr>
	  <tr>
		<td>_</td>
	  </tr>
	</table>
	<table width="100%" border="1">
	  <tr>
		<td width="67%" rowspan="2">-</td>
		<td width="33%">
		  <span class="textColorBlue"><strong>IDEX Asset No. </strong></span>
		</td>
	  </tr>
	  <tr>
		<td>_</td>
	  </tr>
	</table>
	<table width="100%" border="1">
	  <tr>
		<td width="67%" rowspan="2">-</td>
		<td width="33%">
		  <span class="textColorBlue"><strong>IDEX Asset No. </strong></span>
		</td>
	  </tr>
	  <tr>
		<td>_</td>
	  </tr>
	</table>
	<table width="100%" border="1">
	  <tr>
		<td width="67%" rowspan="2">-</td>
		<td width="33%">
		  <span class="textColorBlue"><strong>IDEX Asset No. </strong></span>
		</td>
	  </tr>
	  <tr>
		<td>_</td>
	  </tr>
	</table> -->
			<p align="center" class="textColorBlue">
				<em>
					<strong>
						Attach photographs of Tooling showing asset number and/or asset tag or
						label on Tooling
					</strong>
				</em>
			</p>
			<p>
				<strong>The Supplier named above hereby confirms and agrees that the Tooling
					listed above has been loaned to it by the IDEX Unit named above under
					and subject to the terms and conditions of its Supplier Tooling Loan
					Agreement</strong>
			</p>
			<table width="100%">
				<tr style="border-top: 1px solid black; border-right: 1px solid black">
					<td rowspan="3">
						<p style="position: relative; padding-bottom: 10px;">
							<strong>By:
								<span style="color: black; padding-left: 7px">{{supplierdata[0]?.supplierName}}</span>
								<span style="position: absolute; top: 1px; left: 20px">
									__________________________
								</span></strong>
						</p>
					</td>
					<td class="borderNone" style="position: relative; padding-bottom: 10px">
						<strong>Name:
							<span style="color: black; padding-left: 7px">{{getSafeTitle(supplierdata[0]?.name)}}</span>
							<span style="position: absolute; top: 2px; left: 44px">
								__________________________
							</span></strong>
					</td>
				</tr>
				<tr style="border-right: 1px solid black">
					<td class="borderNone" style="position: relative; padding-bottom: 10px">
						<strong>Title:
							<span
								style="color: black; padding-left: 7px">{{getSafeTitle(supplierdata[0]?.title)}}</span>
							<span style="position: absolute; top: 2px; left: 37px">
								__________________________
							</span></strong>
					</td>
				</tr>
				<tr style="border-bottom: 1px solid black; border-right: 1px solid black">
					<td class="borderNone" style="position: relative; padding-bottom: 10px">
						<strong>Date:
							<span
								style="color: black; padding-left: 7px">{{getSafeFormattedDate(supplierdata[0]?.date)}}</span>
							<span style="position: absolute; top: 2px; left: 38px">
								__________________________
							</span></strong>
					</td>
				</tr>
			</table>
			<p>&nbsp;</p>
		</body>
	</div>
	<div class="form-group text-right add-listings-btn">
		<button type="submit" class="submit_btn m-0" style="margin-right:5px !important;" (click)="pdfdownload()">
			Download Pdf
		</button>
	</div>
</p-dialog>


<p-dialog header="Assign Checker 2" [breakpoints]="{'850px' : '90vw'}" [(visible)]="checker2assign" [modal]="true"
	[style]="{ width: '80vw' }" [baseZIndex]="10001" [draggable]="false" [resizable]="false" [closable]="true"
	[closeOnEscape]="true">
	<div class="row">
		<div class="col-lg-4 col-md-12">
			<div class="form-group">
				<label for="user-role">Select Checker 2<span class="star_class">*</span></label>
				<select class="form-control form-select" [(ngModel)]="selectedChecker2Id">
					<option value="" disabled>Select Checker 2</option>
					<ng-container *ngFor="let user of checker2list">
						<option [value]="user.checker2Id">{{user.checker2Name }}</option>
					</ng-container>
				</select>

			</div>
		</div>
		<div class="col-lg-4 col-md-12">
			<div class="add-listings-btn">
				<button class="mr-2 submit_btn" type="submit" (click)="sendchecker2()" style="margin-top: 8%;">
					Send For Checker 2 Approval
				</button>
			</div>
		</div>
	</div>
</p-dialog>





<p-dialog header="Assign Checker 3" [breakpoints]="{'850px' : '90vw'}" [(visible)]="checker3assign" [modal]="true"
	[style]="{ width: '80vw' }" [baseZIndex]="10001" [draggable]="false" [resizable]="false" [closable]="true"
	[closeOnEscape]="true">
	<div class="row">
		<div class="col-lg-4 col-md-12">
			<div class="form-group">
				<label for="user-role">Select Checker 3<span class="star_class">*</span></label>
				<select class="form-control form-select" [(ngModel)]="selectedChecker3Id">
					<option value="" disabled>Select Checker 3</option>
					<ng-container *ngFor="let user of checker3list">
						<option [value]="user.checker3Id">{{user.checker3Name }}</option>
					</ng-container>
				</select>

			</div>
		</div>
		<div class="col-lg-4 col-md-12">
			<div class="add-listings-btn">
				<button class="mr-2 submit_btn" type="submit" (click)="sendchecker3()" style="margin-top: 8%;">
					Send For Checker 3 Approval
				</button>
			</div>
		</div>
	</div>
</p-dialog>